import { render } from "./BankAccountFirstTime.vue?vue&type=template&id=2b19f8bc"
import script from "./BankAccountFirstTime.vue?vue&type=script&lang=js"
export * from "./BankAccountFirstTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__